import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../../Url";
import { MaritalListActionTypes } from "./ActionTypes";
import { MaritalStatusResponse } from "./Model";
import {
  MaritalListAPIResClearAction,
  MaritalListErrorAction,
  MaritalListLoadingAction,
  MaritalListSuccessAction,
  MaritalListAPIMsgAction,
} from "./Action";
import { headers } from "../../../components/Utility";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";

let apiRes = {} as MaritalStatusResponse;
export const maritalListApi = () => {
  return function (dispatch: Dispatch<MaritalListActionTypes>) {
    dispatch(MaritalListLoadingAction(true));
    setupInterceptorsTo(axios)
      .get(Url.baseUrl + `/patientapp/api/patient/maritial_list_dropdown`, {
        headers: headers,
      })
      .then((res) => {
        apiRes = res.data;
        dispatch(MaritalListLoadingAction(false));
        dispatch(
          MaritalListSuccessAction(
            res.data,
            res.data.message !== undefined
              ? res.data.message
              : "Marital status list fetch successfully."
          )
        );
      })
      .catch((error) => {
        dispatch(MaritalListLoadingAction(false));
        dispatch(
          MaritalListErrorAction(
            {} as MaritalStatusResponse,
            error.response.data !== undefined
              ? error.response.data.message !== undefined
                ? error.response.data.message
                : "Something went wrong"
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0
          )
        );
      });
  };
};

export const MaritalListAPIResMsg = () => {
  return function (dispatch: Dispatch<MaritalListActionTypes>) {
    dispatch(MaritalListAPIMsgAction(apiRes as MaritalStatusResponse, "", "", 0));
  };
};

export const clearMaritalListAPIRes = () => {
  return function (dispatch: Dispatch<MaritalListActionTypes>) {
    dispatch(MaritalListAPIResClearAction({} as MaritalStatusResponse, "", "", 0));
  };
};
